import { CategoryQuestions } from '../types';

export const sexualWellnessWomenQuestions: CategoryQuestions = {
  title: 'Personalize Your Women\'s Sexual Wellness Session',
  questions: {
    preferredStyle: {
      label: 'What healing approach resonates most with you?',
      type: 'radio',
      options: ['Body-positive affirmations and self-love', 'Trauma-informed gentle healing', 'Mindfulness and present-moment awareness', 'Empowerment and reclaiming agency']
    },
    primaryGoal: {
      label: 'What aspect of sexual wellness would you like to focus on today?',
      type: 'radio',
      options: ['Body confidence and self-acceptance', 'Pleasure and sensuality exploration', 'Healing from past trauma or shame', 'Communication and intimacy skills', 'Rekindling desire and libido', 'Mindful intimacy and connection']
    },
    primaryFocus: {
      label: 'What additional area would be helpful to explore?',
      type: 'radio',
      options: ['Body confidence and self-acceptance', 'Pleasure and sensuality exploration', 'Healing from past trauma or shame', 'Communication and intimacy skills', 'Rekindling desire and libido', 'Mindful intimacy and connection']
    },
    currentChallenges: {
      label: 'What challenges are you currently experiencing? (Optional)',
      type: 'textarea',
      placeholder: 'Share what you\'re comfortable discussing - this helps create a more personalized session...'
    },
    healingApproach: {
      label: 'What additional healing approach interests you?',
      type: 'radio',
      options: ['Body-positive affirmations and self-love', 'Trauma-informed gentle healing', 'Mindfulness and present-moment awareness', 'Empowerment and reclaiming agency', 'Sensual exploration and pleasure', 'Communication and boundary setting']
    },
    emotionalTone: {
      label: 'What emotional tone would be most helpful for you?',
      type: 'radio',
      options: ['Gentle and nurturing', 'Empowering and confident', 'Healing and compassionate', 'Playful and light-hearted', 'Grounding and centering', 'Encouraging and supportive']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  groupTitle: 'Personalize Your Group Women\'s Sexual Wellness Session',
  groupQuestions: {
    preferredStyle: {
      label: 'What healing approach works best for your group?',
      type: 'radio',
      options: ['Body-positive and affirming', 'Trauma-informed and gentle', 'Mindfulness-based', 'Empowerment-focused']
    },
    primaryGoal: {
      label: 'What is the primary focus for your group?',
      type: 'radio',
      options: ['Body confidence and acceptance', 'Healing shame and trauma', 'Communication skills', 'Pleasure and sensuality education', 'Relationship wellness', 'Boundary setting and empowerment', 'General sexual wellness education']
    },
    groupContext: {
      label: 'What type of group session are you creating?',
      type: 'radio',
      options: ['Women\'s support circle', 'Therapy group session', 'Educational workshop', 'Healing circle for trauma survivors', 'Body positivity group', 'Relationship wellness group', 'Professional training session']
    },
    groupFocus: {
      label: 'What additional area should the group explore?',
      type: 'radio',
      options: ['Body confidence and acceptance', 'Healing shame and trauma', 'Communication skills', 'Pleasure and sensuality education', 'Relationship wellness', 'Boundary setting and empowerment', 'General sexual wellness education']
    },
    groupDynamics: {
      label: 'How does your group prefer to engage with sensitive topics?',
      type: 'radio',
      options: ['Open discussion and sharing', 'Individual reflection with light sharing', 'Educational format with minimal personal sharing', 'Silent practice with group energy', 'Guided exercises with partner work', 'Anonymous written sharing']
    },
    safetyLevel: {
      label: 'What level of emotional safety does your group need?',
      type: 'radio',
      options: ['Trauma-informed with gentle approach', 'Professional therapeutic setting', 'Educational and informational focus', 'Supportive but not therapy-focused', 'Empowering and strength-based']
    },
    participantBackground: {
      label: 'What best describes your group participants? (Optional)',
      type: 'textarea',
      placeholder: 'Share relevant context about ages, backgrounds, or specific needs to help customize the session...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerGroupTitle: 'Personalize Your Clients\' Group Women\'s Sexual Wellness Session',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What healing approach works best for your clients?',
      type: 'radio',
      options: ['Body-positive and affirming', 'Trauma-informed and gentle', 'Mindfulness-based', 'Empowerment-focused']
    },
    primaryGoal: {
      label: 'What is the primary focus for your clients?',
      type: 'radio',
      options: ['Body confidence and acceptance', 'Healing shame and trauma', 'Communication skills', 'Pleasure and sensuality education', 'Relationship wellness', 'Boundary setting and empowerment', 'General sexual wellness education']
    },
    groupContext: {
      label: 'What type of group session are you creating for your clients?',
      type: 'radio',
      options: ['Women\'s support circle', 'Therapy group session', 'Educational workshop', 'Healing circle for trauma survivors', 'Body positivity group', 'Relationship wellness group', 'Professional training session']
    },
    groupFocus: {
      label: 'What additional area should your clients explore?',
      type: 'radio',
      options: ['Body confidence and acceptance', 'Healing shame and trauma', 'Communication skills', 'Pleasure and sensuality education', 'Relationship wellness', 'Boundary setting and empowerment', 'General sexual wellness education']
    },
    groupDynamics: {
      label: 'How do your clients prefer to engage with sensitive topics?',
      type: 'radio',
      options: ['Open discussion and sharing', 'Individual reflection with light sharing', 'Educational format with minimal personal sharing', 'Silent practice with group energy', 'Guided exercises with partner work', 'Anonymous written sharing']
    },
    safetyLevel: {
      label: 'What level of emotional safety do your clients need?',
      type: 'radio',
      options: ['Trauma-informed with gentle approach', 'Professional therapeutic setting', 'Educational and informational focus', 'Supportive but not therapy-focused', 'Empowering and strength-based']
    },
    participantBackground: {
      label: 'What best describes your clients? (Optional)',
      type: 'textarea',
      placeholder: 'Share relevant context about ages, backgrounds, or specific needs to help customize the session...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerTitle: 'Personalize Your Client\'s Women\'s Sexual Wellness Session',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What healing approach resonates most with your client?',
      type: 'radio',
      options: ['Body-positive affirmations and self-love', 'Trauma-informed gentle healing', 'Mindfulness and present-moment awareness', 'Empowerment and reclaiming agency']
    },
    primaryGoal: {
      label: 'What aspect of sexual wellness would your client like to focus on today?',
      type: 'radio',
      options: ['Body confidence and self-acceptance', 'Pleasure and sensuality exploration', 'Healing from past trauma or shame', 'Communication and intimacy skills', 'Rekindling desire and libido', 'Mindful intimacy and connection']
    },
    primaryFocus: {
      label: 'What additional area would be helpful for your client?',
      type: 'radio',
      options: ['Body confidence and self-acceptance', 'Pleasure and sensuality exploration', 'Healing from past trauma or shame', 'Communication and intimacy skills', 'Rekindling desire and libido', 'Mindful intimacy and connection']
    },
    currentChallenges: {
      label: 'What challenges is your client currently experiencing? (Optional)',
      type: 'textarea',
      placeholder: 'Share what you know about your client\'s challenges - this helps create a more personalized session...'
    },
    healingApproach: {
      label: 'What additional healing approach interests your client?',
      type: 'radio',
      options: ['Body-positive affirmations and self-love', 'Trauma-informed gentle healing', 'Mindfulness and present-moment awareness', 'Empowerment and reclaiming agency', 'Sensual exploration and pleasure', 'Communication and boundary setting']
    },
    emotionalTone: {
      label: 'What emotional tone would be most helpful for your client?',
      type: 'radio',
      options: ['Gentle and nurturing', 'Empowering and confident', 'Healing and compassionate', 'Playful and light-hearted', 'Grounding and centering', 'Encouraging and supportive']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  giftTitle: 'Personalize Sexual Wellness Session for Your Loved One',
  giftQuestions: {
    preferredStyle: {
      label: 'What healing approach resonates most with them?',
      type: 'radio',
      options: ['Body-positive affirmations and self-love', 'Trauma-informed gentle healing', 'Mindfulness and present-moment awareness', 'Empowerment and reclaiming agency']
    },
    primaryGoal: {
      label: 'What aspect of sexual wellness would they like to focus on?',
      type: 'radio',
      options: ['Body confidence and self-acceptance', 'Pleasure and sensuality exploration', 'Healing from past trauma or shame', 'Communication and intimacy skills', 'Rekindling desire and libido', 'Mindful intimacy and connection']
    },
    emotionalTone: {
      label: 'What emotional tone would be most helpful for them?',
      type: 'radio',
      options: ['Gentle and nurturing', 'Empowering and confident', 'Healing and compassionate', 'Playful and light-hearted', 'Grounding and centering']
    },
    currentChallenges: {
      label: 'What challenges are they currently experiencing? (Optional)',
      type: 'textarea',
      placeholder: 'Share what you know about their challenges - this helps create a more personalized session...'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};